import { Gap } from 'lib/components/styles/layout';
import React, { useMemo } from 'react';
import { useFormikContext } from 'formik';
import TitleAndCategoryForm from './TitleAndCategoryForm';
import ResellersAndCustomersForm from './ResellersAndCustomersForm';
import { Divider } from '../form/styles';
import {
  IResellersWithCustomers,
  IResellersWithCustomersResponse,
} from 'lib/api/superadmin/useGetResellerCustomerCounts';
import {
  RefetchOptions,
  RefetchQueryFilters,
  QueryObserverResult,
  InfiniteData,
} from 'react-query';
import { ILandingPageBuilderForm } from '../../types';
import { useAuth } from 'lib/context';
import CustomersForm from './CustomersForm';

interface ILandingPageBuilderAccessFormProps {
  resellers: IResellersWithCustomers[];
  count: number;
  refetch: <TPageData>(
    options?: (RefetchOptions & RefetchQueryFilters<TPageData>) | undefined
  ) => Promise<
    QueryObserverResult<InfiniteData<IResellersWithCustomersResponse>, unknown>
  >;
  isFetching: boolean;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  page: number;
  setResellersData: React.Dispatch<
    React.SetStateAction<IResellersWithCustomers[]>
  >;
  resellersData: IResellersWithCustomers[];
  isCovideoSuperAdmin: boolean;
  isResellerAdmin: boolean;
}

const LandingPageBuilderAccessForm = ({
  resellers,
  refetch,
  count,
  isFetching,
  page,
  setPage,
  setResellersData,
  resellersData,
  isCovideoSuperAdmin,
  isResellerAdmin,
}: ILandingPageBuilderAccessFormProps) => {
  const { values, setFieldValue } = useFormikContext<ILandingPageBuilderForm>();
  const { userData } = useAuth();

  const memoizedResellers = useMemo(() => resellers, [resellers]);
  const memoizedResellersData = useMemo(() => resellersData, [resellersData]);
  const memoizedValues = useMemo(
    () => ({
      access: values.access,
      selectedResellerId: values.selectedResellerId,
    }),
    [values.access, values.selectedResellerId]
  );

  return (
    <Gap
      gap='0'
      flexDirection='column'
      style={{ width: '100%', maxWidth: '797px' }}
    >
      <TitleAndCategoryForm isCovideoSuperAdmin={isCovideoSuperAdmin} />
      <Divider />
      {isCovideoSuperAdmin ? (
        <ResellersAndCustomersForm
          resellers={memoizedResellers}
          refetch={refetch}
          count={count}
          isFetching={isFetching}
          page={page}
          setPage={setPage}
          setResellersData={setResellersData}
          resellersData={memoizedResellersData}
          setFieldValue={setFieldValue}
          values={memoizedValues}
          isResellerAdmin={isResellerAdmin}
        />
      ) : (
        <CustomersForm
          resellerId={Number(userData.resellerId)}
          isResellerAdmin={isResellerAdmin}
        />
      )}
    </Gap>
  );
};

export default LandingPageBuilderAccessForm;
